import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { ModalOrderConfirmation } from "~/components/kiosk/ui/modals/checkout/order-confirmation";
import { useAppContext } from "~/providers/app";
import { useKioskSession } from "~/stores/kiosk-session/hooks/use-kiosk-session";
import { useKioskSessionReset } from "~/stores/kiosk-session/hooks/use-kiosk-session-reset";

export const KioskBasketOrderConfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const receiptList = (
    location.state as { receiptList?: string[] } | null | undefined
  )?.receiptList;

  const orderId = useKioskSession((session) => session?.orderId);

  const resetSession = useKioskSessionReset();

  const {
    hardware: { printer }
  } = useAppContext();

  if (!orderId) {
    return <Navigate to="/kiosk/basket" />;
  }

  return (
    <ModalOrderConfirmation
      onClose={resetSession}
      onPrintReceipt={
        printer
          ? () => {
              navigate("print", { state: { receiptList } });
            }
          : null
      }
      onSendReceipt={() => {
        navigate("email");
      }}
    />
  );
};
